<template>
  <div
    :style="theme ? {
      color: theme?.base.text.base
    } : {}"
    class="relative flex flex-col space-y-3 pt-3 px-3"
  >
    <!-- HEADER -->
    <div
      class="font-bold flex items-center space-x-2"
      v-if="(type === 'post' || type === 'post-main') && size !== 'sm'"
    > 
      <NuxtLink :to="{ query: { ...(route.query ?? {}), user: owner?.username } }" class="flex items-center overflow-hidden space-x-2 w-full text-sm" v-if="isHideUser">
        <UserPicture :user="owner" size="sm" />

        <div class="line-clamp-1 break-all">{{ owner?.name }}</div>

        <span class="font-medium text-charcoal-500 shrink-0 dark:text-dark-400">
          {{ (owner?.pronouns ?? []).length > 0 ? owner?.pronouns.join('/') + ' · ' : '' }}
          {{ dayjs(post?.createdAt).fromNow(true) }}
        </span>
      </NuxtLink>
      <NuxtLink :to="{ name: 'app-groups-slug', params: { slug: group?.slug ?? 'all' } }"  class="flex items-center overflow-hidden space-x-1.5 w-full text-sm" v-else-if="group">
        <div class="size-5 rounded-sm bg-cover bg-center bg-charcoal-950 shrink-0" :style="{ backgroundImage: `url(${group?.banner ? group.banner.getSize('s') : bannerPlaceholder })` }" />

        <div class="line-clamp-1 break-all">{{ (group?.name ?? 'Vibes') }}</div>

        <span class="font-medium text-charcoal-500 shrink-0 dark:text-dark-400">
          {{ dayjs(post?.createdAt).fromNow(true) }}
        </span>
      </NuxtLink>
      <div class="grow" v-else />

      <div class="shrink-0 flex items-center self-start space-x-1.5">
        <ButtonBase class="relative z-10" :color="group.application === 'open' ? 'builders' : 'white'" size="3xs" @click="() => groupsStore.join(group?._id ?? '')" v-if="group && !group.isMember(currentUser?._id) && !isHideActions && !isHideUser">
          <span class="text-2xs">
            <IconBase name="cute/lock-fill" :width="12" class="align-baseline" v-if="group.application !== 'open'" />

            {{ $t('actions.join') }}
          </span>
        </ButtonBase>
        <!-- <ButtonBase @click="() => groupsStore.leave(group?._id ?? '')" color="white" class="shrink-0" size="3xs" v-else-if="group && group.isMember(currentUser?._id) && !isHideActions && !isHideUser">
          <span class="text-2xs">{{ $t('actions.joined') }}</span>
        </ButtonBase> -->

        <!-- <ButtonBase class="relative z-10" color="builders" :to="{ query: { ...(route?.query ?? {}), complete: true }}" :size="type.includes('post-') ? 'xs' : '2xs'" v-else-if="!group && !currentUser?.isOnboarded2 && !isHideActions">
          <span class="px-1.5 text-xs">{{ $t('actions.follow') }}</span>
        </ButtonBase>
        <ButtonBase class="relative z-10" color="xweak" :size="type.includes('post-') ? 'xs' : '2xs'" @click="() => onFollow()" :is-loading="isLoading" v-else-if="!group && following.includes(post?.owner ?? '') && post?.owner !== currentUser?._id && !isHideActions">
          <span class="px-1.5 text-xs">{{ $t('common.followed') }}</span>
        </ButtonBase>
        <ButtonBase class="relative z-10" color="builders" :size="type.includes('post-') ? 'xs' : '2xs'" @click="() => onFollow()" :is-loading="isLoading" v-else-if="!group && !following.includes(post?.owner ?? '') && owner?.isMessageable && post?.owner !== currentUser?._id && !isHideActions">
          <span class="px-1.5 text-xs">{{ $t('actions.follow') }}</span>
        </ButtonBase> -->

        <ButtonBase size="3xs" style-type="round" @click="onContextMenu" color="white">
          <IconBase name="cute/dots-h" :width="16" />
        </ButtonBase>
      </div>
    </div>
    
    <!-- CONTENT -->
    <div class="space-y-3">

      <div class="font-bold text-md !leading-[1.32] is-title" v-if="(post?.title) && (type === 'post' || type === 'post-main')">
        {{ post?.title ? post.translated(currentUser, langExcluded).title : 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' }}
        
        <div class="bg-ruby-200 text-ruby-800 text-5xs mx-1 -mt-0.5 align-middle text-shadow-none font-black inline-flex items-center space-x-0.5 pr-1.5 pl-1 py-0.5 rounded-full uppercase" v-if="post.isSpicy">
          <IconBase name="cute/fire-fill" :width="11" />
          <span>{{ $t('components.Group.spicy') }}</span>
        </div>
        <div class="bg-royal-200 text-royal-800 text-5xs mx-1 -mt-0.5 align-middle text-shadow-none font-black inline-flex items-center space-x-0.5 pr-1.5 pl-1 py-0.5 rounded-full uppercase" v-if="post?.isPinned">
          <IconBase name="cute/pin-fill" :width="11" />
          <span>{{ $t('components.Post.pinned') }}</span>
        </div>
      </div>
      
      <div class="bg-light-200 dark:bg-dark-700 overflow-hidden -mx-3" :style="post.medias[0].palette ? { backgroundColor: `rgba(${post.medias[0].palette.Vibrant.join(',')}, 0.5)` } : {}" v-if="post?.medias?.[0] && post.medias.length === 1">
        <div
          class="relative cursor-pointer overflow-hidden mx-auto"
          :style="{
            width: post.medias[0]?.getRatio('m', width, 400).width + 'px',
            height: post.medias[0]?.getRatio('m', width, 400).height + 'px'
          }"
        >
          <img
            class="absolute w-full h-full"
            :src="post.medias[0]?.getSize('m')"
            :class="[
              isBlur ? 'blur-lg' : '',
              (post.medias[0]?.isSpoiler && !revealed.includes(post.medias[0]?._id)) ? 'blur-lg scale-110' : ''
            ]"
            :width="post.medias[0]?.getRatio('m', width, 400).width"
            :height="post.medias[0]?.getRatio('m', width, 400).height"
            loading="lazy"
            @click="() => post?.promotion?.link ? openLink() : popinStore.displayMedias(post?.medias ?? [])"
          />

          <div 
            class="text-center absolute top-0 left-0 bg-charcoal-800/30 size-full flex items-center justify-center"
            @click.stop="() => onReveal(post?.medias[0]?._id ?? '')"
            v-if="(post.medias[0]?.isSpoiler && !revealed.includes(post.medias[0]?._id))"
          >
            <ButtonBase size="xs" color="white" class="mx-auto">
              <LazyIconBase name="cute/eye" class="mr-1" /> {{ $t('actions.reveal') }}
            </ButtonBase>
          </div>
        </div>
      </div>
      <div class="bg-light-200 dark:bg-dark-700 -mx-3" v-else-if="post && post.medias.length > 1">
        <div class="py-3">
          <CarouselScroll padding="p-0 pl-3" @scroll-start="() => emit('scroll-start')" @scroll-end="() => emit('scroll-end')" gradient="from-charcoal-200/0 to-charcoal-200/50 dark:from-dark-700/0 dark:to-dark-700">
            <div class="flex items-center space-x-1.5">
              <div
                class="shrink-0 cursor-pointer relative rounded-md overflow-hidden"
                v-for="(media, i) in post.medias"
              >
                <img
                  class="max-w-none rounded-md"

                  :class="[
                    isBlur ? 'blur-lg' : '',
                    (media.isSpoiler && !revealed.includes(media._id)) ? 'blur-lg scale-110' : ''
                  ]"
                  :src="media.getSize('s')"
                  @click="() => popinStore.displayMedias(post?.medias ?? [], i)" :width="media.getRatio('s', 9999, 224).width"
                  :height="media.getRatio('s', 9999, 224).height"
                  draggable="false"
                  loading="lazy"
                />

                <div class="text-center absolute top-0 left-0 bg-charcoal-800/30 size-full flex items-center justify-center" v-if="(media.isSpoiler && !revealed.includes(media._id))">
                  <ButtonBase size="xs" color="white" class="mx-auto" @click.stop="() => onReveal(media._id)">
                    <LazyIconBase name="cute/eye" class="mr-1" /> {{ $t('actions.reveal' )}}
                  </ButtonBase>
                </div>

                <div class="absolute top-2 left-2 bg-charcoal-950/50 text-white text-3xs px-2 py-1 rounded-full font-bold">
                  {{ i + 1 }} / {{ post.medias.length }}
                </div>
              </div>
            </div>
          </CarouselScroll>
        </div>
      </div>
      <div class="overflow-hidden relative bg-light-200 h-20 rounded-xl dark:bg-dark-700" v-else-if="post?.attachments?.spotify">
        <iframe style="border-radius:12px" :src="`https://open.spotify.com/embed/track/${post.attachments.spotify}`" width="100%" height="150" frameBorder="0" allowfullscreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" v-if="isVisible" />
      </div>
      <div class="-mx-3 relative aspect-video bg-light-200 dark:bg-dark-700" v-else-if="post?.attachments?.youtube">
        <iframe
          class="absolute top-0 left-0 w-full h-full overflow-hidden"
          :src="`https://www.youtube-nocookie.com/embed/${post.attachments.youtube}`" 
          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          loading="lazy"
          v-if="isVisible"
        />
      </div>

      <TextHider2
        :content="post.translated(currentUser, langExcluded).content"
        :lines="type === 'post-main' ? 10 : lineClamp"
        :bg="type === 'comment-reply' ? 'bg-light-200 dark:bg-dark-700' : (type === 'post-main' ? 'bg-light-50 dark:bg-dark-950' : undefined)"
        :gradient="type === 'comment-reply' ? 'from-light-200/0 to-light-200 dark:from-dark-700/0 dark:to-dark-700' : (type === 'post-main' ? 'from-light-50/0 to-light-50 dark:from-dark-950/0 dark:to-dark-950' : undefined)"
        class="select-none md:select-auto amp-mask is-description"
        v-if="post && stripTags(post.content).length > 0"
      >
        <InputTextareaPaper
          v-model="post.translated(currentUser, langExcluded).content"
          body-class="text-post"
          :class="[ type === 'post' || type === 'post-main' ? 'dark:text-dark-300' : 'dark:text-dark-50' ]"
          is-mentions
          is-read-only
        />
      </TextHider2>

      <TranslationButton :post="post" v-if="post && post?.lang !== currentUser?.langTarget && currentUser?.isLangTranslate" />

      <PostAttachmentPoll
        :post="post"
        class="-mx-3"
        v-if="post?.attachments?.poll && post.attachments.poll.options && post.attachments.poll.options.length >= 2"
      />

      <div class="space-y-2" v-if="(post?.attachments?.link || post?.attachments?.group || post?.attachments?.event || post?.attachments?.post) && (!post?.attachments?.youtube && !post?.attachments?.spotify)">
        <MetadataBlock :link="post?.attachments?.link" v-if="post?.attachments?.link" />

        <div class="bg-charcoal-100 min-h-28 dark:bg-dark-700 rounded-xl flex items-center justify-center" v-if="post?.attachments?.event">
          <EventCard class="grow" :event="event" is-hide-saved v-if="event" />
          <div class="text-center text-light-950/20" v-else>
            {{ $t('components.Post.event.unavailable') }}
          </div>
        </div>

        <div class="min-h-[4.5rem] bg-charcoal-100 dark:bg-dark-700 rounded-xl" v-if="post?.attachments?.group">
          <GroupBlockLine :group="groupAttached" :token="post?.attachments?.token" v-if="groupAttached" />
        </div>
      </div>
      <div class="flex flex-wrap gap-1 -mx-0.5" v-if="post && group && (post?.flairs ?? []).length > 0">
        <div class="text-white text-3xs align-middle text-shadow-none font-medium px-2 py-0.5 rounded-full" :style="{ backgroundColor: flair.color ?? '#000000' }" v-for="flair in group.flairify(post.flairs)" :key="flair._id">
          <span>{{ flair.label }}</span>
        </div>
      </div>
    </div>

    <div @click="openLink" class="bg-royal-800 block cursor-pointer text-white font-medium shrink-0" v-if="post?.promotion?.link && !isHideActions">
      <div class="flex items-center pl-3.5 pr-2.5 h-12">
        <p class="grow">{{ post.promotion.linkTitle ?? 'Voir' }}</p>
        <IconBase name="cute/angle-right" class="shrink-0" />
      </div>
    </div>

    <div class="relative shrink-0" v-if="!isHideActions && post">
      <PostActions
        :post="post"
        :parent="parent"
        :is-hide-cheers="isHideCheers"
        :type="type"
        :types="[
          'comments',
          ...(isVotes ? ['votes'] : ['likes']),
          ...(isHideUser ? [] : [ 'user' ]) as any,
          ...(type.includes('comment') ? ['date', 'menu'] : []),
          ...(size === 'sm' ? ['user-sm', 'date', 'menu'] : [])
        ]"
        @scroll-start="() => emit('scroll-start')"
        @scroll-end="() => emit('scroll-end')"
        @answer="() => emit('answer', post?._id ?? '', !canReply)"
      />
    </div>

    <div class="-mx-3" ref="$sizer" />

    <div class="bg-charcoal-950/30 dark:bg-dark-600/80 absolute z-[50] top-0 left-0 w-full h-full" @click="() => isReactions = false" v-if="isReactions" />
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'
import EventsStore from '@/store/events'
import PostsStore from '@/store/posts'
import { Post, Theme } from '@/classes'
import PopinStore from '@/store/popin'
import UsersStore from '@/store/users'
import ContextStore from '@/store/context'
import GroupsStore from '@/store/groups'
import SentimentStore from '@/store/sentiments'
import PostAttachmentPoll from './PostAttachment/PostAttachmentPoll.vue'
import dayjs from 'dayjs'
import bannerPlaceholder from '@/assets/img/gradients/hard/gradient-6.jpg'

const props = withDefaults(defineProps<{
  post?: Post | null
  parent?: Post | null
  theme?: Theme | null
  type?: 'post' | 'post-main' | 'comment' | 'comment-reply'
  canReply?: boolean
  size?: 'base' | 'sm'
  lineClamp?: number
  isVisible: boolean
  isHideActions?: boolean
  isVotes?: boolean
  isHideUser?: boolean
  isHideCheers?: boolean
  isHideGroup?: boolean
  isPopin?: boolean
}>(), {
  post: null,
  parent: null,
  group: null,
  size: 'base',
  owner: null,
  lineClamp: 3,
  canReply: true,
  type: 'post',
  theme: null,
  isVotes: false,
  isVisible: true,
  isHideCheers: false,
  isHideActions: false,
  isHideGroup: false,
  isHideUser: false,
  isPopin: false
})

const route = useRoute()

const eventStore = EventsStore()
const usersStore = UsersStore()
const groupsStore = GroupsStore()
const sentimentsStore = SentimentStore()
const popinStore = PopinStore()
const postsStore = PostsStore()
const userStore = UserStore()
const { currentUser, langExcluded } = storeToRefs(userStore)

const $sizer = ref()
const { width } = useElementSize($sizer)

const isReactions = ref(false)

const owner = computed(() => props.post?.owner ? usersStore.getItem(props.post.owner) : null)
const event = computed(() => props.post?.attachments?.event ? eventStore.getItem(props.post?.attachments.event) : null)
const group = computed(() => props.post?.group ? groupsStore.getItem(props.post.group) : null)
const groupAttached = computed(() => props.post?.attachments?.group ? groupsStore.getItem(props.post?.attachments.group) : null)

watch(isReactions, () => {
  if (isReactions.value) {
    emit('scroll-start')
  } else {
    emit('scroll-end')
  }
})

// SPOILERS

const revealed: Ref<string[]> = ref([])
const onReveal = (_id: string) => {
  revealed.value.push(_id)
}

const openLink = () => {
  if (!props.post?.promotion?.link) return

  window.location = redirect({ url: props.post.promotion?.link, postId: props.post._id, origin: 'link', userId: currentUser.value?._id ?? '' }) as any
}

const { showContextMenu } = ContextStore()
const onContextMenu = () => {
  showContextMenu(
    {
      post: props.post ?? undefined,
      postParent: props.parent ?? undefined,
      group: group.value ?? undefined,
      event: event.value ?? undefined,
      user: owner.value ?? undefined,
    },
    ['post']
  )
}


const isBlur = ref(false)

onMounted(async () => {
  isBlur.value = currentUser.value?.isAdmin && await getCookie('is-blur') ? true : false
})

// HOOKS

const emit = defineEmits<{
  (e: 'answer', postId: string, isComment: boolean): void
  (e: 'scroll-start'): void
  (e: 'scroll-end'): void
}>()
</script>

<style lang="scss" scoped>

.is-title + .is-description {
  margin-top: 0.4rem !important;
}

</style>